module.exports = __webpack_public_path__ + "static/img/certificat_Company.fe38b36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/certificat_Company.png
// module id = L/VY
// module chunks = 0